exports.components = {
  "component---node-modules-dvcorg-gatsby-theme-iterative-src-templates-doc-tsx": () => import("./../../../node_modules/@dvcorg/gatsby-theme-iterative/src/templates/doc.tsx" /* webpackChunkName: "component---node-modules-dvcorg-gatsby-theme-iterative-src-templates-doc-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

